import { PaymentOptions } from "./Account/SettingsView";
import { InvoiceStatus, RequiredData } from "./Types";

export const fakeData: RequiredData = {
  customer: {
    firstName: "Kalle",
    lastName: "Kula",
    adress: "Fältspatvägen 12",
    city: "Bromma",
    email: "kalle.kula123@gmail.se",
    id: 12312,
    zipCode: 16741,
  },
  subscriptions: [
    {
      adress: "Fältspatvägen 12",
      agreement: "Kampanj 2022",
      id: 5544710,
      period: 1,
      startDate: new Date("2020-12-01"),
      paymentName: PaymentOptions.Autogiro
    }, {
      adress: "Celsiusvägen 5",
      agreement: "Black Friday 2019",
      id: 3231313,
      period: 6,
      startDate: new Date("2019-11-15"),
      paymentName: PaymentOptions.Pappersfaktura
    },
  ],
  invoices: [
    {
      id: 1234,
      link: "https://salesys.se",
      price: 567,
      status: InvoiceStatus.Paid,
      siteId: 123
    },
    {
      id: 1235,
      link: "https://salesys.se",
      price: 23000,
      status: InvoiceStatus.Expired,
      siteId: 123
    },
    {
      id: 1236,
      link: "https://salesys.se",
      price: 3200,
      status: InvoiceStatus.Unpaid,
      siteId: 123
    },
    {
      id: 1234,
      link: "https://salesys.se",
      price: 567,
      status: InvoiceStatus.Paid,
      siteId: 123
    },
    {
      id: 1235,
      link: "https://salesys.se",
      price: 23000,
      status: InvoiceStatus.Expired,
      siteId: 123
    },
    {
      id: 1236,
      link: "https://salesys.se",
      price: 3200,
      status: InvoiceStatus.Unpaid,
      siteId: 123
    }, {
      id: 1234,
      link: "https://salesys.se",
      price: 567,
      status: InvoiceStatus.Paid,
      siteId: 123
    },
    {
      id: 1235,
      link: "https://salesys.se",
      price: 23000,
      status: InvoiceStatus.Expired,
      siteId: 123
    },
    {
      id: 1236,
      link: "https://salesys.se",
      price: 3200,
      status: InvoiceStatus.Unpaid,
      siteId: 123
    },

  ],
};